import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class KycDataService {
  private data?: {
    bucket: string;
    name: string;
    type: 'PERSONAL' | 'CLAIM';
    multiple: boolean;
    ref: string;
    provider?: string;
    isComponentView?: boolean;
  };

  constructor() {}

  setData(data: {
    bucket: string;
    name: string;
    type: 'PERSONAL' | 'CLAIM';
    multiple: boolean;
    ref: string;
    provider?: string;
    isComponentView?: boolean;
  }) {
    this.data = data;
  }

  getData() {
    return this.data;
  }
}
